import React from "react"
import Link from "gatsby-link"
import SEO from '../components/SEO'
import SVGInline from 'react-svg-inline'
import * as PropTypes from "prop-types"
import Img from "gatsby-image"

//
// const propTypes = {
//   data: PropTypes.object.isRequired,
// }

class ArticleTemplate extends React.Component {
  render() {
    const article = this.props.data.contentfulArticle;
    const {
      title,
      slug,
      date,
      text,
      excerpt,
      cover,
      tags
    } = article;
    const pageSEO = {
      title: title,
      description: excerpt,
      path: `/articole/${slug}/`
    };
    return (
      <div className="o-page__content o-page__content--center">
        <SEO pageSEO={pageSEO} article />

        <header className="c-section-gradient">
          <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
            <h1 className="c-page__heading">{title}</h1>
            <div className="c-article-misc c-article-misc--center u-mb-0">
              <div className="c-article-date">
                {date}
              </div>
              <span className="u-ph-10 c-article-misc__separator">|</span>
              <div className="c-article-tags">
                <ul className="o-list-inline o-list-05 u-mb-0 o-media__body">
                  {tags.map((tag, i) => (
                    <li key={i} className="o-list-inline__item">
                      <Link to={`/articole/etichete/${tag.slug}/`} className="c-tag">
                        {tag.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </header>

        <div className="o-container u-pt-20 u-pt-30@tablet">
          <article className="c-article u-pb-20 u-pb-30@tablet">

            {cover && cover.resolutions && cover.title && cover.resolutions.src && (
              <Img
                className="c-article__cover u-mb-20 u-mb-30@tablet"
                alt={cover.title}
                resolutions={cover.resolutions}
              />
            )}

            <div className="o-container o-container--text">
              <div
                className="c-markdown"
                dangerouslySetInnerHTML={{
                  __html: text.childMarkdownRemark.html,
                }}
              />

              <div className="u-text-center">
                <Link to="/preturi/" className="c-button u-mt-30">
                  Solicita o oferta personalizata
                </Link>
              </div>
            </div>
          </article>

        </div>

      </div>
    )
  }
}

// ArticleTemplate.propTypes = propTypes;

export default ArticleTemplate;

export const pageQuery = graphql`
  query articleQuery($slug: String) {
    contentfulArticle(slug: { eq: $slug }) {
      title
      slug
      date
      excerpt
      cover {
        title
        resolutions(width: 1048, height: 400) {
          ...GatsbyContentfulResolutions_noBase64
        }
      }
      tags {
        slug
        name
      }
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/article.js